/* tslint:disable */
/* eslint-disable */
/**
 * Yaway API
 * Yaway API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiServiceThemeData
 */
export interface ApiServiceThemeData {
    /**
     * 
     * @type {string}
     * @memberof ApiServiceThemeData
     */
    logo: string;
    /**
     * 
     * @type {string}
     * @memberof ApiServiceThemeData
     */
    color: string;
}

export function ApiServiceThemeDataFromJSON(json: any): ApiServiceThemeData {
    return ApiServiceThemeDataFromJSONTyped(json, false);
}

export function ApiServiceThemeDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiServiceThemeData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'logo': json['logo'],
        'color': json['color'],
    };
}

export function ApiServiceThemeDataToJSON(value?: ApiServiceThemeData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'logo': value.logo,
        'color': value.color,
    };
}

